import isEmpty from "lodash/isEmpty"

export default function validateInput(data) {
  const lang_code = localStorage.getItem("lang")

  const lang_required = {
    fr: {
      message_required: `Ce champ est requis`,
    },
    en: {
      message_required: `This field is required`,
    },
    sw: {
      message_required: `Ni lazima kujaza nafasi hii`,
    },
    ZARMA: {
      message_required: `Tilas batamo hima ga bara`,
    },
    HAOUSSA: {
      message_required: `Doole hilin ga shina nan`,
    },
    es: {
      message_required: `Este campo es requerido`,
    },
    ar: {
      message_required: `هذا الحقل اجباري`,
    },
    pt: {
      message_required: `Este campo é obrigatório`,
    },
  }

  let errors = {}

  if (data.phone_number === "") {
    errors.phone_number = lang_required[lang_code].message_required
  }

  return {
    errors,
    isValid: isEmpty(errors),
  }
}
